import React from "react";
import "./Video.css";
import { Link } from "react-router-dom";
import ReactPlayer from "react-player";
import axios from "axios";
import Pagination from "./Pagination";
import { baseURL } from "../Config/Config";
import userPhoto from "../assets/user.png"
import { VideoContext } from "../context/video_context";

export default function Video() {
  const [posts, setPosts] = React.useState();
  const [category, setCategory] = React.useState("");
  const [videoContextData] = React.useContext(VideoContext);

  const [page, setPage] = React.useState(1);
  const [current_page, setCurrent_page] = React.useState();
  const [total_pages, setTotal_pages] = React.useState();

  React.useEffect(() => {
    axios
      .get(
        `${baseURL}video/video-material-list/?category=${category}&page=${page}`
      )
      .then((response) => {
        setPosts(response.data.results);
        setCurrent_page(response.data.current_page);
        setTotal_pages(response.data.total_pages);
      });
  }, [category, page]);
  const hadleFilter = (id, e) => {
    setCategory(id);
  };
  if (!posts) return (<div className="spinnerBlog">
    <div className="spinner">
    </div>
  </div>);

  return (
    <div>
      <div className="container video_name">
        <h1 className="daraja_name">Video materiallar</h1>
      </div>
      <div className="container">
        <div className="video-materials">
          <div className="video-top">
            <div className="left">
              <Link to="/" className="bosh">
                Bosh sahifa
              </Link>
              <Link className="left-material">Video materiallar</Link>
            </div>
          </div>
          <div className="video-cards">
            <div className="video-left">
              {posts.map((post, id) => {
                return (
                  <div className="video-box" key={post.id}>
                    <div className="video-card">
                      <ReactPlayer
                        className="video video"
                        url={post.video_link}
                        controls = {true}
                      />
                    </div>
                    <div className="card-box">
                      <div className="name">
                        <div className="muallif-img">
                          <img src={post.author_photo ? post.author_photo : userPhoto} alt="some img" />
                        </div>
                        <span>{post.author}</span>
                      </div>
                      <div className="card-box-title">
                        <Link to={`/VideoMaterial/${post.id}`}>
                          {post.title}
                        </Link>
                        <p>{post.sub_content}</p>
                      </div>
                      <div className="card-box-bottom">
                        <div className="card-data">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10 2C14.411 2 18 5.589 18 10C18 14.411 14.411 18 10 18C5.589 18 2 14.411 2 10C2 5.589 5.589 2 10 2ZM10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0ZM13.8 13.4L11 9.667V5H9V10.333L12.2 14.599L13.8 13.4Z"
                              fill="#4ECB71"
                            />
                          </svg>
                          <span>5:43</span>
                        </div>
                        <div>|</div>
                        <div className="card-calendar">
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M14.5 17C15.163 17 15.7989 16.7366 16.2678 16.2678C16.7366 15.7989 17 15.163 17 14.5C17 13.837 16.7366 13.2011 16.2678 12.7322C15.7989 12.2634 15.163 12 14.5 12C13.837 12 13.2011 12.2634 12.7322 12.7322C12.2634 13.2011 12 13.837 12 14.5C12 15.163 12.2634 15.7989 12.7322 16.2678C13.2011 16.7366 13.837 17 14.5 17ZM14.5 18C15.4283 18 16.3185 17.6313 16.9749 16.9749C17.6313 16.3185 18 15.4283 18 14.5C18 13.5717 17.6313 12.6815 16.9749 12.0251C16.3185 11.3687 15.4283 11 14.5 11C13.5717 11 12.6815 11.3687 12.0251 12.0251C11.3687 12.6815 11 13.5717 11 14.5C11 15.4283 11.3687 16.3185 12.0251 16.9749C12.6815 17.6313 13.5717 18 14.5 18Z"
                              fill="#4ECB71"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M14.5 12.75C14.6326 12.75 14.7598 12.8027 14.8536 12.8964C14.9473 12.9902 15 13.1174 15 13.25V14.293L15.3535 14.6465C15.4446 14.7408 15.495 14.8671 15.4938 14.9982C15.4927 15.1293 15.4401 15.2547 15.3474 15.3474C15.2547 15.4401 15.1293 15.4927 14.9982 15.4938C14.8671 15.495 14.7408 15.4446 14.6465 15.3535L14 14.707V13.25C14 13.1174 14.0527 12.9902 14.1464 12.8964C14.2402 12.8027 14.3674 12.75 14.5 12.75ZM4 8.5H3V9.5H4V8.5ZM3 7.5C2.73478 7.5 2.48043 7.60536 2.29289 7.79289C2.10536 7.98043 2 8.23478 2 8.5V9.5C2 9.76522 2.10536 10.0196 2.29289 10.2071C2.48043 10.3946 2.73478 10.5 3 10.5H4C4.26522 10.5 4.51957 10.3946 4.70711 10.2071C4.89464 10.0196 5 9.76522 5 9.5V8.5C5 8.23478 4.89464 7.98043 4.70711 7.79289C4.51957 7.60536 4.26522 7.5 4 7.5H3ZM8 8.5H7V9.5H8V8.5ZM7 7.5C6.73478 7.5 6.48043 7.60536 6.29289 7.79289C6.10536 7.98043 6 8.23478 6 8.5V9.5C6 9.76522 6.10536 10.0196 6.29289 10.2071C6.48043 10.3946 6.73478 10.5 7 10.5H8C8.26522 10.5 8.51957 10.3946 8.70711 10.2071C8.89464 10.0196 9 9.76522 9 9.5V8.5C9 8.23478 8.89464 7.98043 8.70711 7.79289C8.51957 7.60536 8.26522 7.5 8 7.5H7ZM12 8.5H11V9.5H12V8.5ZM11 7.5C10.7348 7.5 10.4804 7.60536 10.2929 7.79289C10.1054 7.98043 10 8.23478 10 8.5V9.5C10 9.76522 10.1054 10.0196 10.2929 10.2071C10.4804 10.3946 10.7348 10.5 11 10.5H12C12.2652 10.5 12.5196 10.3946 12.7071 10.2071C12.8946 10.0196 13 9.76522 13 9.5V8.5C13 8.23478 12.8946 7.98043 12.7071 7.79289C12.5196 7.60536 12.2652 7.5 12 7.5H11ZM4 12.5H3V13.5H4V12.5ZM3 11.5C2.73478 11.5 2.48043 11.6054 2.29289 11.7929C2.10536 11.9804 2 12.2348 2 12.5V13.5C2 13.7652 2.10536 14.0196 2.29289 14.2071C2.48043 14.3946 2.73478 14.5 3 14.5H4C4.26522 14.5 4.51957 14.3946 4.70711 14.2071C4.89464 14.0196 5 13.7652 5 13.5V12.5C5 12.2348 4.89464 11.9804 4.70711 11.7929C4.51957 11.6054 4.26522 11.5 4 11.5H3ZM8 12.5H7V13.5H8V12.5ZM7 11.5C6.73478 11.5 6.48043 11.6054 6.29289 11.7929C6.10536 11.9804 6 12.2348 6 12.5V13.5C6 13.7652 6.10536 14.0196 6.29289 14.2071C6.48043 14.3946 6.73478 14.5 7 14.5H8C8.26522 14.5 8.51957 14.3946 8.70711 14.2071C8.89464 14.0196 9 13.7652 9 13.5V12.5C9 12.2348 8.89464 11.9804 8.70711 11.7929C8.51957 11.6054 8.26522 11.5 8 11.5H7Z"
                              fill="#4ECB71"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M1 3C1 2.86739 1.05268 2.74021 1.14645 2.64645C1.24021 2.55268 1.36739 2.5 1.5 2.5H4V1.5H1.5C1.10218 1.5 0.720644 1.65804 0.43934 1.93934C0.158035 2.22064 0 2.60218 0 3V15C0 15.3978 0.158035 15.7794 0.43934 16.0607C0.720644 16.342 1.10218 16.5 1.5 16.5H11.6275C11.4143 16.1946 11.2514 15.857 11.145 15.5H1.5C1.36739 15.5 1.24021 15.4473 1.14645 15.3536C1.05268 15.2598 1 15.1326 1 15V3ZM14 11.035C14.3316 10.9876 14.6684 10.9876 15 11.035V3C15 2.60218 14.842 2.22064 14.5607 1.93934C14.2794 1.65804 13.8978 1.5 13.5 1.5H12V2.5H13.5C13.6326 2.5 13.7598 2.55268 13.8536 2.64645C13.9473 2.74021 14 2.86739 14 3V11.035ZM5 2.5H10.2815V1.5H5V2.5Z"
                              fill="#4ECB71"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M11 1.5H5V3C5 3.13261 4.94732 3.25979 4.85355 3.35355C4.75979 3.44732 4.63261 3.5 4.5 3.5C4.36739 3.5 4.24021 3.44732 4.14645 3.35355C4.05268 3.25979 4 3.13261 4 3V1.5H1.5C1.23478 1.5 0.98043 1.60536 0.792893 1.79289C0.605357 1.98043 0.5 2.23478 0.5 2.5V5C0.5 5.26522 0.605357 5.51957 0.792893 5.70711C0.98043 5.89464 1.23478 6 1.5 6H13.5C13.7652 6 14.0196 5.89464 14.2071 5.70711C14.3946 5.51957 14.5 5.26522 14.5 5V2.5C14.5 2.23478 14.3946 1.98043 14.2071 1.79289C14.0196 1.60536 13.7652 1.5 13.5 1.5H12V3C12 3.13261 11.9473 3.25979 11.8536 3.35355C11.7598 3.44732 11.6326 3.5 11.5 3.5C11.3674 3.5 11.2402 3.44732 11.1464 3.35355C11.0527 3.25979 11 3.13261 11 3V1.5Z"
                              fill="#4ECB71"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M15 6H1V5H15V6Z"
                              fill="#4ECB71"
                            />
                            <path
                              d="M3 0.5C3 0.367392 3.05268 0.240215 3.14645 0.146447C3.24021 0.0526785 3.36739 0 3.5 0C3.63261 0 3.75979 0.0526785 3.85355 0.146447C3.94732 0.240215 4 0.367392 4 0.5V2.5C4 2.63261 3.94732 2.75979 3.85355 2.85355C3.75979 2.94732 3.63261 3 3.5 3C3.36739 3 3.24021 2.94732 3.14645 2.85355C3.05268 2.75979 3 2.63261 3 2.5V0.5ZM10 0.5C10 0.367392 10.0527 0.240215 10.1464 0.146447C10.2402 0.0526785 10.3674 0 10.5 0C10.6326 0 10.7598 0.0526785 10.8536 0.146447C10.9473 0.240215 11 0.367392 11 0.5V2.5C11 2.63261 10.9473 2.75979 10.8536 2.85355C10.7598 2.94732 10.6326 3 10.5 3C10.3674 3 10.2402 2.94732 10.1464 2.85355C10.0527 2.75979 10 2.63261 10 2.5V0.5Z"
                              fill="#4ECB71"
                            />
                          </svg>
                          <span>21 jun 2022</span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            <div>
              <div className="video-right">
                <div className="video-turi">
                  <label htmlFor="all">
                    <span> Barchasi</span>
                    <input
                      type="radio"
                      name="name"
                      id="all"
                      onClick={(e) => hadleFilter("", e)}
                    />
                  </label>
                  {videoContextData.map((item) => {
                    return (
                      <div key={item.id}>
                        <label htmlFor={item.id}>
                          <span> {item.title}</span>
                          <input
                            type="radio"
                            name="name"
                            id={item.id}
                            onClick={(e) => hadleFilter(item.id, e)}
                          />
                        </label>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

          </div>
          <Pagination
            setPage={setPage}
            current_page={current_page}
            total_pages={total_pages}
          />
        </div>
      </div>
    </div>
  );
}
